import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import Select, { Option } from "@cs/components/src/Select";
import ApiService from "../../services/ApiService";

const Wrapper = styled.div`
  margin-right: 20px;
  min-width: 250px;
`;

const SelectOrganization = () => {
  const { systemDomainId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Wrapper>
      <Select
        placeholder="Select an organization"
        value={systemDomainId}
        onChange={({ value }) => {
          navigate(
            location.pathname
              .replace(/dashboard\/[^/]*\//, `dashboard/${value}/`)
              .replace(/plugin\/.*/, "plugin")
          );
        }}
        optionsAsync={{
          key: `_/organization`,
          fn: async () =>
            (
              await ApiService.fetch<{ data: Option[] }>(
                "GET",
                `/api/select_option/_/organization`
              )
            ).data,
        }}
      ></Select>
    </Wrapper>
  );
};

export default SelectOrganization;
